import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import style from "./read-more-less.css";
import SVGIcon from "../svg-icon/svg-icon";
import { gettext } from "web/script/modules/django-i18n";

export function ReadMoreLessArea({ displayText, expanded, label, itemAttributes, onClick }) {
    return (
        <React.Fragment>
            <span {...itemAttributes}>{displayText}</span>
            <div className={style.readMoreLessText} onClick={onClick}>
                {label}
                <SVGIcon name="round-chevron" rotate={expanded ? 270 : 90} />
            </div>
        </React.Fragment>
    );
}
ReadMoreLessArea.propTypes = {
    displayText: PropTypes.string.isRequired,
    expanded: PropTypes.bool.isRequired,
    label: PropTypes.string.isRequired,
    itemAttributes: PropTypes.object,
    onClick: PropTypes.func.isRequired
};
ReadMoreLessArea.defaultProps = {
    itemAttributes: {}
};

function ReadMoreLess({ charLimit, readMoreLabel, readLessLabel, text, itemAttributes }) {
    const textOverLimit = text.length > charLimit;
    const [readMoreRequired, setReadMoreRequired] = useState(false);
    const [expanded, setExpanded] = useState(!textOverLimit);

    useEffect(() => {
        // Write full text to the DOM in SSR then truncate in browser ...
        setReadMoreRequired(textOverLimit);
    }, [textOverLimit]);

    let displayText;
    let label;

    if (!readMoreRequired || expanded) {
        displayText = text;
        label = readLessLabel;
    } else {
        displayText = `${text.substr(0, charLimit)}\u2026 `;
        label = readMoreLabel;
    }

    return (
        <div className={style.shortText}>
            {readMoreRequired ? (
                <ReadMoreLessArea
                    displayText={displayText}
                    expanded={expanded}
                    label={label}
                    itemAttributes={itemAttributes}
                    onClick={() => setExpanded(!expanded)}
                />
            ) : (
                <span {...itemAttributes}>{text}</span>
            )}
        </div>
    );
}

ReadMoreLess.propTypes = {
    charLimit: PropTypes.number,
    readMoreLabel: PropTypes.string,
    readLessLabel: PropTypes.string,
    text: PropTypes.string.isRequired,
    itemAttributes: PropTypes.object
};

ReadMoreLess.defaultProps = {
    charLimit: 150,
    readMoreLabel: gettext("general.read_more"),
    readLessLabel: gettext("general.read_less"),
    itemAttributes: {}
};

export default ReadMoreLess;
